export const PERMISSIONS = [
    // Tizim
    { code: 'rbac.role.manage', group: 'Tizim', label: 'Rollarni boshqarish' },
    { code: 'rbac.assignment.manage', group: 'Tizim', label: 'Rol biriktirishni boshqarish' },
    { code: 'rbac.permission.read', group: 'Tizim', label: 'Ruxsatlar ro\'yxatini ko\'rish' },
    { code: 'audit.read', group: 'Tizim', label: 'Audit jurnalini ko\'rish' },
    // Foydalanuvchi
    { code: 'user.read', group: 'Foydalanuvchi', label: 'Xodimlarni ko\'rish' },
    { code: 'user.create', group: 'Foydalanuvchi', label: 'Xodim qo\'shish' },
    { code: 'user.update', group: 'Foydalanuvchi', label: 'Xodimni tahrirlash' },
    { code: 'user.password.reset', group: 'Foydalanuvchi', label: 'Parolni tiklash' },
    // Tashkiliy tuzilma
    { code: 'org.unit.read', group: 'Tuzilma', label: 'Korxonalarni ko\'rish' },
    { code: 'org.unit.manage', group: 'Tuzilma', label: 'Korxonalarni boshqarish' },
    { code: 'org.position.manage', group: 'Tuzilma', label: 'Lavozimlarni boshqarish' },
    { code: 'subdivision.read', group: 'Tuzilma', label: 'Bo\'linmalarni ko\'rish' },
    { code: 'subdivision.manage', group: 'Tuzilma', label: 'Bo\'linmalarni boshqarish' },
    { code: 'subdivision.stock.read', group: 'Tuzilma', label: 'Bo\'linma qoldig\'ini ko\'rish' },
    { code: 'storeroom.manage', group: 'Tuzilma', label: 'Bo\'linma omborlarini boshqarish' },
    {
        code: 'subdivision.stock.import',
        group: 'Tuzilma',
        label: 'Boshlang\'ich qoldiq kiritish',
    },
    { code: 'storeroom.usage.read', group: 'Tuzilma', label: 'Ishlatish tarixini ko\'rish' },
    // Ombor
    { code: 'warehouse.read', group: 'Ombor', label: 'Omborlarni ko\'rish' },
    { code: 'warehouse.create', group: 'Ombor', label: 'Ombor yaratish' },
    { code: 'warehouse.layout.edit', group: 'Ombor', label: 'Ombor tuzilmasini tahrirlash' },
    { code: 'warehouse.label.print', group: 'Ombor', label: 'Etiketka bosib chiqarish' },
    // Katalog va qoldiq
    { code: 'catalog.read', group: 'Katalog', label: 'Nomenklaturani ko\'rish' },
    { code: 'catalog.manage', group: 'Katalog', label: 'Nomenklaturani boshqarish' },
    { code: 'stock.read', group: 'Qoldiq', label: 'Qoldiqni ko\'rish' },
    { code: 'stock.receive', group: 'Qoldiq', label: 'Kirim qilish' },
    { code: 'stock.receive.import', group: 'Qoldiq', label: 'Excel orqali kirim import qilish' },
    { code: 'stock.move', group: 'Qoldiq', label: 'Katakdan katakka ko\'chirish' },
    { code: 'stock.issue', group: 'Qoldiq', label: 'Mahsulot berish (chiqim)' },
    { code: 'stock.adjust', group: 'Qoldiq', label: 'Kirimni bekor qilish (tuzatish)' },
    { code: 'stock.supply.upload', group: 'Qoldiq', label: '1C moddiy hisobotini yuklash' },
    { code: 'stock.supply.place', group: 'Qoldiq', label: 'Hisobot bo\'yicha joylashtirish' },
    // Talabnoma
    { code: 'requisition.read', group: 'Talabnoma', label: 'Talabnomalarni ko\'rish' },
    { code: 'requisition.create', group: 'Talabnoma', label: 'Talabnoma yaratish' },
    { code: 'requisition.submit', group: 'Talabnoma', label: 'Talabnomani yuborish' },
    { code: 'requisition.cancel', group: 'Talabnoma', label: 'Talabnomani bekor qilish' },
    { code: 'requisition.approve.org', group: 'Talabnoma', label: 'Korxona nomidan tasdiqlash' },
    { code: 'requisition.reject.org', group: 'Talabnoma', label: 'Korxona nomidan rad etish' },
    { code: 'requisition.accept.warehouse', group: 'Talabnoma', label: 'Sklad qabul qilishi' },
    { code: 'requisition.reject.warehouse', group: 'Talabnoma', label: 'Sklad rad etishi' },
    { code: 'requisition.confirm.receipt', group: 'Talabnoma', label: 'Qabul qilinganini tasdiqlash' },
    // Buxgalteriya
    { code: 'accounting.survey.create', group: 'Buxgalteriya', label: 'So\'rovnoma ochish' },
    { code: 'accounting.survey.approve', group: 'Buxgalteriya', label: 'So\'rovnomani tasdiqlash' },
    { code: 'accounting.survey.reject', group: 'Buxgalteriya', label: 'So\'rovnomani rad etish' },
    { code: 'accounting.doc.read', group: 'Buxgalteriya', label: 'Prixod hujjatlarini ko\'rish' },
    // Rasxod
    { code: 'writeoff.create', group: 'Rasxod', label: 'Rasxod akti yuborish' },
    { code: 'writeoff.read', group: 'Rasxod', label: 'Rasxod aktlarini ko\'rish' },
    { code: 'writeoff.approve', group: 'Rasxod', label: 'Rasxodni tasdiqlash' },
    { code: 'writeoff.reject', group: 'Rasxod', label: 'Rasxodni rad etish' },
    // Bildirgi — qoldiqda yo'q mahsulot uchun ariza
    { code: 'backorder.create', group: 'Bildirgi', label: 'Bildirgi yuborish' },
    { code: 'backorder.accept', group: 'Bildirgi', label: 'Bildirgini qabul qilish va biriktirish' },
    { code: 'backorder.oversee', group: 'Bildirgi', label: 'Korxona bildirgilarini kuzatish' },
    // Fayl
    { code: 'files.upload', group: 'Fayl', label: 'Fayl yuklash (rasm, hujjat)' },
    { code: 'files.read', group: 'Fayl', label: 'Faylni ochish va yuklab olish' },
    // Hisobot
    { code: 'report.view', group: 'Hisobot', label: 'Hisobotlarni ko\'rish' },
];
export const PERMISSION_CODES = PERMISSIONS.map((p) => p.code);
export const isKnownPermission = (code) => PERMISSION_CODES.includes(code);
/**
 * OMBOR DARAJASIDAGI ruxsatlar.
 *
 * Bu ro'yxatdagi ruxsat aniq bitta OMBORDA ma'noga ega: "kirim qilish" degani
 * doim "falon omborga kirim qilish". Korxona doirasida berilsa, xodim o'sha
 * korxonaning HAMMA omboriga kirib qoladi — KMO da aynan shu bo'lgan va
 * kimning qaysi omborga javob berishi hech qachon ayon bo'lmagan.
 *
 * Ro'yxat SHU YERDA turadi, chunki uni ikki tomon ham biladi: frontend
 * tanlagichni "Ombor" ga qulflaydi, backend esa biriktiruvni rad etadi.
 * Ikki joyda yozilsa, bir kun ajralib ketadi va qoida jimgina yo'qoladi.
 */
export const WAREHOUSE_SCOPED_PERMISSIONS = [
    'stock.receive',
    'stock.receive.import',
    'stock.move',
    'stock.issue',
    'stock.adjust',
    'stock.supply.place',
    'requisition.accept.warehouse',
    'requisition.reject.warehouse',
    'accounting.survey.create',
    /* Bildirgini qabul qilish AYNAN bitta omborda ma'noga ega: skladchi
       o'z omboriga keladigan narsani va'da qiladi. */
    'backorder.accept',
    'warehouse.layout.edit',
    'warehouse.label.print',
];
/**
 * OMBORDAN YUQORIDA turadigan ruxsatlar.
 *
 * Bularga ega rol ombor ichida emas, ombor USTIDA ishlaydi: rol taqsimlaydi,
 * xodim qo'shadi, tuzilma boshqaradi, korxona nomidan tasdiqlaydi yoki yangi
 * ombor ochadi. Bunday rolning doirasi tabiiy ravishda MTU yoki korxona
 * bo'ladi.
 */
export const ORG_SCOPED_PERMISSIONS = [
    'rbac.role.manage',
    'rbac.assignment.manage',
    'user.create',
    'user.update',
    'org.unit.manage',
    'org.position.manage',
    'subdivision.manage',
    'warehouse.create',
    'requisition.approve.org',
    'requisition.reject.org',
    'accounting.survey.approve',
    'accounting.survey.reject',
    /* Rasxodni tasdiqlash ombor ICHIDA emas, uning USTIDA turadi: moddiy
       buxgalter korxonaning barcha bo'linmalarini ko'radi va unga ombor
       biriktirishning ma'nosi yo'q (`roleNeedsWarehouse`). */
    'writeoff.approve',
    'writeoff.reject',
    /* Rahbar bildirgilarni ombor ICHIDA emas, korxona ustidan kuzatadi:
       uning qaramog'idagi hamma bildirgi bitta ro'yxatda ko'rinishi kerak. */
    'backorder.oversee',
];
/**
 * Rol ombor roli — ya'ni unga ombor biriktirilishi SHART — mi?
 *
 * IKKI shart, va ikkinchisi birinchisidan kam emas:
 *   1. rolda ombor darajasidagi ruxsat bor;
 *   2. rolda ombordan YUQORIDAGI ruxsat YO'Q.
 *
 * Ikkinchi shartsiz qoida superadmin ustida sinadi: unda barcha ruxsatlar
 * bor, shu jumladan `stock.receive` ham — va u bitta omborga qamalib
 * qolardi. Ma'no esa boshqa: skladchi ombor ICHIDA ishlaydi, administrator
 * esa uning USTIDA.
 *
 * Alohida bayroq (`role.isWarehouseRole`) qo'yilmadi: u rolning ruxsatlaridan
 * ajralib qolishi mumkin edi (ruxsat olib tashlanadi, bayroq qoladi). Qoida
 * ruxsatlarning O'ZIDAN hisoblanadi va hech qachon eskirmaydi.
 */
export const roleNeedsWarehouse = (permissions) => permissions.some((code) => WAREHOUSE_SCOPED_PERMISSIONS.includes(code)) &&
    !permissions.some((code) => ORG_SCOPED_PERMISSIONS.includes(code));
//# sourceMappingURL=permissions.js.map